import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { className: "bg-[#ffffff] pt-[6rem] pb-[6rem]" }
const _hoisted_2 = { className: "mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { className: "text-[1.25rem] px-6 leading-[1.2] sm:px-0 sm:text-[57px] text-[#02021E] font-[800] text-center m-auto pb-[2rem]" }, " Our Latest Updates ", -1)
const _hoisted_4 = { className: "flex justify-between card3spacing flex-wrap sm:flex-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Card3 = _resolveComponent("Card3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Card3, { src_image: "pseudo.png" }),
        _createVNode(_component_Card3, { src_image: "pseudo.png" }),
        _createVNode(_component_Card3, { src_image: "pseudo.png" })
      ])
    ])
  ]))
}